/*
	YOUTUBE VIDEO CONTROLS
 */

video = {
	init: function () {
		video.loadYouTubeAPI.then(function (result) {
			video.cE();
			video.eL();
		}, function(err) {
			console.log(err);
		});

	},
	cE: function () {
		video.livaloVideo;
		video.pamVideo;
		video.robertVideo;
		video.debbieVideo;
		video.donnieVideo;
		video.pamVideoNew;

		video.youTubeArray = [];
		video.readyForScrollEvent = [];
	},
	eL: function () {
		if ($('body').hasClass('goal-getters')){
			$(window).on('load', function () {
				video.youTubeArray = [];

				var videos = ['debbieVideo', 'pamVideo', 'robertVideo', 'donnieVideo', 'jayVideo', 'janeVideo', 'jeanetteVideo'];

				for (var i = 0; i < videos.length; i++){
					video.onYouTubeIframeAPIReady(videos[i]);
				}
			});
		}

		if ($('body').hasClass('what-is-livalo')){
			$(window).on('load', function () {
				video.onYouTubeIframeAPIReady('livaloVideo');
			});
		}

		if ($('body').hasClass('lander-page')){
			$(window).on('load', function () {
				video.onYouTubeIframeAPIReady('pamVideoNew');
			});
		}

        if ($('body').hasClass('understanding-page')){
            $(window).on('load', function () {
                video.onYouTubeIframeAPIReady('robertVideo');
            });
        }
        if ($('body').hasClass('starting-page')){
            $(window).on('load', function () {
                video.onYouTubeIframeAPIReady('donnieVideo');
            });
        }
        if ($('body').hasClass('discovering-page')){
            $(window).on('load', function () {
                video.onYouTubeIframeAPIReady('jayVideo');
            });
        }
        if ($('body').hasClass('discovering-page')){
            $(window).on('load', function () {
                video.onYouTubeIframeAPIReady('janeVideo');
            });
        }
        if ($('body').hasClass('discovering-page')){
            $(window).on('load', function () {
                video.onYouTubeIframeAPIReady('jeanetteVideo');
            });
        }
	},
	loadYouTubeAPI: new Promise(function(resolve, reject){
			// This code loads the IFrame Player API code asynchronously.
			var tag = document.createElement('script');
			tag.src = "https://www.youtube.com/iframe_api";
			var firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
			resolve('this works');
			reject(Error('There is an error'));
	}),
	onYouTubeIframeAPIReady: function (patientVideo) {
		// console.log('hitting youtube iframe ready ',patientVideo);
		switch(patientVideo){
			case 'pamVideoNew':
				video.pamVideoNew = new YT.Player(patientVideo, {
					videoId: 'kVjleI3gXds',
					height: '315',
					width: '560,',
					playerVars: {
						'rel': '0',
						'showinfo': '0',
						'origin': window.location.origin
					},
					events: {
						'onReady': video.onPlayerReady,
						'onStateChange': video.onPlayerStateChange
					}
				});
				video.youTubeArray.push(video.pamVideoNew);
				break;
			case 'pamVideo':
				video.pamVideo = new YT.Player(patientVideo, {
					videoId: 'd4dBKapjxOA',
					height: '315',
					width: '560,',
					playerVars: {
						'rel': '0',
						'showinfo': '0',
						'origin': window.location.origin
					},
					events: {
						'onReady': video.onPlayerReady,
						'onStateChange': video.onPlayerStateChange
					}
				});
				video.youTubeArray.push(video.pamVideo);
				break;
			case 'robertVideo':
				video.robertVideo = new YT.Player(patientVideo, {
					videoId: 'OKGFKOJLRes',
					height: '315',
					width: '560,',
					playerVars: {
						'rel': '0',
						'showinfo': '0',
						'origin': window.location.origin
					},
					events: {
						'onReady': video.onPlayerReady,
						'onStateChange': video.onPlayerStateChange
					}
				});
				video.youTubeArray.push(video.robertVideo);
				break;
			case 'debbieVideo':
				video.debbieVideo = new YT.Player(patientVideo, {
					videoId: '_XTHXTku0U8',
					height: '315',
					width: '560,',
					playerVars: {
						'rel': '0',
						'showinfo': '0',
						'origin': window.location.origin
					},
					events: {
						'onReady': video.onPlayerReady,
						'onStateChange': video.onPlayerStateChange
					}
				});
				video.youTubeArray.push(video.debbieVideo);
				break;
			case 'donnieVideo':
				video.donnieVideo = new YT.Player(patientVideo, {
					videoId: 'kNGZYSTpPHc',
					height: '315',
					width: '560,',
					playerVars: {
						'rel': '0',
						'showinfo': '0',
						'origin': window.location.origin
					},
					events: {
						'onReady': video.onPlayerReady,
						'onStateChange': video.onPlayerStateChange
					}
				});
				video.youTubeArray.push(video.donnieVideo);
				break;
            case 'jayVideo':
                video.donnieVideo = new YT.Player(patientVideo, {
                    videoId: '5Dhn0T1PN3w',
                    height: '315',
                    width: '560,',
                    playerVars: {
                        'rel': '0',
                        'showinfo': '0',
                        'origin': window.location.origin
                    },
                    events: {
                        'onReady': video.onPlayerReady,
                        'onStateChange': video.onPlayerStateChange
                    }
                });
                video.youTubeArray.push(video.donnieVideo);
                break;
            case 'janeVideo':
                video.donnieVideo = new YT.Player(patientVideo, {
                    videoId: 'rXGhzsF07IA',
                    height: '315',
                    width: '560,',
                    playerVars: {
                        'rel': '0',
                        'showinfo': '0',
                        'origin': window.location.origin
                    },
                    events: {
                        'onReady': video.onPlayerReady,
                        'onStateChange': video.onPlayerStateChange
                    }
                });
                video.youTubeArray.push(video.donnieVideo);
                break;
            case 'jeanetteVideo':
                video.donnieVideo = new YT.Player(patientVideo, {
                    videoId: 'tRleLT7gn9E',
                    height: '315',
                    width: '560,',
                    playerVars: {
                        'rel': '0',
                        'showinfo': '0',
                        'origin': window.location.origin
                    },
                    events: {
                        'onReady': video.onPlayerReady,
                        'onStateChange': video.onPlayerStateChange
                    }
                });
                video.youTubeArray.push(video.donnieVideo);
                break;
			case 'livaloVideo':
				video.livaloVideo = new YT.Player(patientVideo, {
					videoId: 'VHmlx2RRhWE',
					height: '315',
					width: '560,',
					playerVars: {
						'rel': '0',
						'showinfo': '0',
						'origin': window.location.origin
					},
					events: {
						'onReady': video.onPlayerReady,
						'onStateChange': video.onPlayerStateChange
					}
				});
				video.youTubeArray.push(video.livaloVideo);
				break;
			default:
				// console.log('hitting default on video stuff');
				break;
		}

	},
	onPlayerReady: function(event){
		console.log();
		video.readyForScrollEvent.push(event.target.getIframe().id);
		video.addScrollListener(event.target.getIframe().id);
		//
		if (event.target.getIframe().id === "debbieVideo") {
			$('#debbieVideo-container').addClass('hide-bg');
		} else if (event.target.getIframe().id === "pamVideo") {
			$('#pamVideo-container').addClass('hide-bg');
		} else if (event.target.getIframe().id === "robertVideo") {
			$('#robertVideo-container').addClass('hide-bg');
		} else if (event.target.getIframe().id === "donnieVideo") {
			$('#donnieVideo-container').addClass('hide-bg');
		} else if (event.target.getIframe().id === "jayVideo") {
            $('#jayVideo-container').addClass('hide-bg');
        } else if (event.target.getIframe().id === "janeVideo") {
            $('#janeVideo-container').addClass('hide-bg');
        } else if (event.target.getIframe().id === "jeanetteVideo") {
            $('#jeanetteVideo-container').addClass('hide-bg');
        } else if (event.target.getIframe().id === "pamVideoNew"){
			if ($('body').hasClass('driving')){
				$('#pamVideoNew-container').on('click', function(e){
					e.preventDefault();
					$(this).removeClass('poster-driving');
					$(this).addClass('video-playing');
					video.pamVideoNew.playVideo();
				});
			} else if ($('body').hasClass('portal')){
				$('#pamVideoNew-container').on('click', function(e){
					e.preventDefault();
					$(this).removeClass('poster-portal');
					$(this).addClass('video-playing');
					video.pamVideoNew.playVideo();
				});
			}
		} else if (event.target.getIframe().id === "livaloVideo") {
			$('#livaloVideo-container').addClass('hide-bg');
			if (window.location.hash === "#video"){
				$(window).scrollTop(0);
				setTimeout(function () {
					// smooth scroll to the anchor id
					$('html, body').animate({
						scrollTop: $('#livaloVideo-container').offset().top - 100
					}, 1000);

					event.target.playVideo();
				}, 1000);
			}
		}

		if (event.target.getIframe().id === "livaloVideo") {
			$('#livaloVideo-container').addClass('hide-bg');
			if (window.location.hash === "#video"){
				$(window).scrollTop(0);
				setTimeout(function () {
					// smooth scroll to the anchor id
					$('html, body').animate({
						scrollTop: $('#livaloVideo-container').offset().top - 100
					}, 1000);
					event.target.playVideo();
				}, 1000);
			}
		}
	},
	onPlayerStateChange: function(event){
		if (event.target.getPlayerState() === 1){
			var thisVideo = event.target.getIframe().id;
			console.log(thisVideo);
			video.pauseVideoIfPlaying(thisVideo);

			if ($('body').hasClass('driving')){
				if (event.data === 0) {
					if ( !$('#pamVideoNew-container').hasClass('poster-driving') ) {
						$('#pamVideoNew-container').removeClass('video-playing');
						$('#pamVideoNew-container').addClass('poster-driving');
					}
				}
			} else if ($('body').hasClass('portal')){
				if (event.data === 0) {
					if ( !$('#pamVideoNew-container').hasClass('poster-portal') ) {
						$('#pamVideoNew-container').removeClass('video-playing');
						$('#pamVideoNew-container').addClass('poster-portal');
					}
				}
			}
		}
	},
	addScrollListener: function(targetVideo){
		if (targetVideo === 'livaloVideo'){
			$(window).on('resize scroll', function() {
				if (!video.isInViewport(video.youTubeArray[0].getIframe().parentElement) && video.youTubeArray[0].getPlayerState() === 1){
					video.livaloVideo.pauseVideo();
				}
			});
		} else if (targetVideo === 'pamVideoNew'){
			$(window).on('resize scroll', function() {
				if (!video.isInViewport(video.youTubeArray[0].getIframe().parentElement) && video.youTubeArray[0].getPlayerState() === 1){
					video.pamVideoNew.pauseVideo();
				}
			});
		} else if (video.readyForScrollEvent.length >= 2){
			$(window).on('resize scroll', function() {
				for (var i = 0; i < video.youTubeArray.length; i++){
					// for each of the videos, if the video is playing AND the video is NOT in viewport, then pause the video
					if (video.youTubeArray[i].getPlayerState() === 1 && !video.isInViewport(video.youTubeArray[i].getIframe().parentElement)){
						video.youTubeArray[i].pauseVideo();
					}
				}
			});
		}

	},
	pauseVideoIfPlaying: function(thisVideo){
		for (var i = 0; i < video.youTubeArray.length; i++) {
			// If the video in the array has a PlayerState of 1 (which means it is playing) and its id doesn't match thisVideo, then pause that video
			if (video.youTubeArray[i].getPlayerState() === 1 && video.youTubeArray[i].getIframe().id !== thisVideo) {
				video.youTubeArray[i].pauseVideo();
			}
		}
	},
	isInViewport: function(parentElement){
		var elementTop = $(parentElement).offset().top;
		var elementBottom = elementTop + $(parentElement).outerHeight();
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	}
};
